import React, {Component} from 'react';
import TextField from '../../lib/mdb/text-field';

/**
 * Renders the CVV
 *
 * Expected parameters:
 * FIXME need to update here
 */
class CVV extends Component {
    render() {
        const {config, paymentMethod} = this.props,
            {messages,paymentConfig} = config,
            {type} = paymentMethod,
            {cvvCheckOptional} = paymentConfig;

        let cvvDescription = messages["opp.ccCvv.label"];
        if (cvvCheckOptional) {
            cvvDescription += ` ${messages["optional.label"]}`;
        }

        return (
            <TextField
                name="paymentMethod.cvv"
                placeholder={messages["opp.ccCvv.tip"]}
                description={() => (
                    <React.Fragment>
                        {cvvDescription}
                        <a key="cc-popover-cvv-link" id="cc-popover-cvv-link"
                           tabIndex="-1" className="popover-link"
                           data-toggle="popover" data-placement="auto" data-trigger="hover"
                           data-title={messages["whereIsCvv.title"]}>
                            <i className="material-icons">{messages["opp.ccCvv.help.icon"]}</i></a>
                    </React.Fragment>
                )}
                maxLength={type === "AMEX" ? 4 : 3}
                className="md-form form-group"
                labelClass="has-popover"
                aria-required="true"
                validations={{
                    // Where is the validation for CVV??
                    required: (value) => (!cvvCheckOptional && !value) ? messages["opp.validation.ccCvv.required"]
                                                                       : ''
                }}
                autoComplete="off"
                rightSideSpanClass="pm-cvv-sample"/>
        );
    }
}

export default CVV
